import React, { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { PageTitle, StatCard, fmtDate } from "../../components/admin/AdminUi";
import QrCard from "../../components/getapp/QrCard";
import StoreLinksForm from "../../components/admin/mobile/StoreLinksForm";
import KitList from "../../components/admin/mobile/KitList";
import PublishSteps from "../../components/admin/mobile/PublishSteps";
import DownloadStats from "../../components/admin/mobile/DownloadStats";
import { api } from "../../lib/api";

const PUBLIC_PAGE = "https://ishukart.org/get-app";

export default function AdminMobileApp() {
  const [data, setData] = useState(null);
  useEffect(() => { api.adminMobileApp().then(setData).catch(() => {}); }, []);
  const a = data?.android;
  return (
    <div className="space-y-6" data-testid="admin-mobile-app">
      <PageTitle title="Mobile app" desc="Ishukart as an Android and iPhone app. Share the Get the app page, then list it on the stores when you're ready."
        right={<a href="/get-app" target="_blank" rel="noreferrer" data-testid="mobile-open-page" className="h-9 px-4 inline-flex items-center gap-2 rounded-lg border border-slate-300 text-sm text-slate-700 hover:bg-slate-100"><ExternalLink size={14} /> Open Get the app page</a>} />
      <div className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <StatCard label="Android app" value={a?.available ? `v${a.version}` : "—"} sub={a?.available ? `${a.size_mb} MB · built ${fmtDate(data.built_at)}` : "not built"} testid="mobile-stat-android" />
        <StatCard label="APK downloads" value={data?.apk_downloads ?? "—"} sub="all time" testid="mobile-stat-downloads" />
        <StatCard label="Google Play" value={a?.play_store_url ? "Live" : "Not listed"} accent={a?.play_store_url ? "text-emerald-600" : "text-slate-400"} sub={data?.package_id} testid="mobile-stat-play" />
        <StatCard label="App Store" value={data?.ios?.app_store_url ? "Live" : "Not listed"} accent={data?.ios?.app_store_url ? "text-emerald-600" : "text-slate-400"} sub="iPhone users can add it from Safari today" testid="mobile-stat-appstore" />
      </div>
      <DownloadStats />
      <div className="grid lg:grid-cols-2 gap-6 items-start">
        <div className="space-y-6">
          <QrCard url={PUBLIC_PAGE} testid="mobile-share-qr" title="Share the download link" desc="Put this QR code on your posters, WhatsApp status or website." />
          <StoreLinksForm data={data} onSaved={setData} />
        </div>
        <KitList kit={data?.kit} />
      </div>
      <PublishSteps />
    </div>
  );
}
